export default {
  dateModified: 0,
  srtStats: {
    input: {
      sid: 0,
      time: 0,
      peerIP: "",
      window: {
        flow: 0,
        congestion: 0,
        flight: 0
      },
      link: {
        rtt: 0,
        bandwidth: 0,
        maxBandwidth: 0,
        latency: 0
      },
      send: {
        packets: 0,
        packetsLost: 0,
        packetsDropped: 0,
        packetsRetransmitted: 0,
        packetsTotal: 0,
        packetsLostTotal: 0,
        packetsDroppedTotal: 0,
        bytes: 0,
        bytesDropped: 0,
        mbitRate: 0
      },
      recv: {
        packets: 0,
        packetsLost: 0,
        packetsDropped: 0,
        packetsRetransmitted: 0,
        packetsBelated: 0,
        packetsTotal: 0,
        packetsLostTotal: 0,
        packetsDroppedTotal: 0,
        bytes: 0,
        bytesLost: 0,
        bytesDropped: 0,
        mbitRate: 0
      }
    },
    output: {
      sid: 0,
      time: 0,
      peerIP: "",
      window: {
        flow: 0,
        congestion: 0,
        flight: 0
      },
      link: {
        rtt: 0,
        bandwidth: 0,
        maxBandwidth: 0,
        latency: 0
      },
      send: {
        packets: 0,
        packetsLost: 0,
        packetsDropped: 0,
        packetsRetransmitted: 0,
        bytes: 0,
        bytesDropped: 0,
        mbitRate: 0
      },
      recv: {
        packets: 0,
        packetsLost: 0,
        packetsDropped: 0,
        packetsRetransmitted: 0,
        packetsBelated: 0,
        bytes: 0,
        bytesLost: 0,
        bytesDropped: 0,
        mbitRate: 0
      }
    },
    containerStatusInput: {},
    containerStatusOutput: {},
  },
  tsReport: {
    input: {
      tsID: "",
      network_name: "",
      programs: [],
      tables: []
    },
    output: {
      tsID: "",
      network_name: "",
      programs: [],
      tables: []
    }
  },
  streamList: {
    containers: [{
      Id: 0,
      ttl: "",
      timeout: -1,
      interval: 0,
      sourceSrtMode: "",
      sourceAdapter: "",
      sourceProtocol: "",
      sourceIP: "",
      sourcePort: "",
      sourceSSMIP: "",
      sourceOutgoingPort: "",
      sourceLatency: "",
      sourceDropPackets: true,
      sourceTimeout: "",
      sourceEncryption: "Disabled",
      sourceEncryptionKey: "",
      destSrtMode: "",
      destAdapter: "",
      destProtocol: "",
      destIP: "",
      destPort: "",
      destOutgoingPort: "",
      destLatency: "",
      destDropPackets: true,
      destTimeout: "",
      destEncryption: "Disabled",
      destEncryptionKey: ""
    }],
    selectedContainerId: 0,
    inputStats: {
      bandwith: [],
      latency: []
    },
    outputStats: {
      bandwith: [],
      latency: []
    },
    backupFiles: [],
    localConfig: {
      pageSize: 5
    }
  },
  streamConfig: {
    container: {
      Id: 0,
      ttl: 0,
      timeout: -1,
      interval: 30,
      comment:"",
      sourceSrtMode: "",
      sourceAdapter: "",
      sourceAdapterIP: "",
      sourceProtocol: "",
      sourceIP: "",
      sourcePort: "",
      sourceLatency: "150",
      sourceDropPackets: true,
      sourceTimeout: "",
      sourceTtl: "32",
      sourceEncryption: "Disabled",
      sourceEncryptionKey: "",
      destSrtMode: "",
      destAdapter: "",
      destAdapterIP: "",
      destProtocol: "",
      destIP: "",
      destPort: "",
      destLatency: "150",
      destDropPackets: true,
      destTimeout: "",
      destTtl: "32",
      destEncryption: "Disabled",
      destEncryptionKey: "",
      qamConfig: {
        frequency: "",
        mode: "",
        interleaver: ""
      }
    }
  },
  sysConfig: {
    nics: {
      eth: [{
        eth0: {
          address: "",
          gateway: "",
          netmask: "",
          isManagement: "",

        }
      }],
      managementPort: ""
    },
    about: {
      licenses: 0,
      demoMode: "",
      demoModeTimeout: 0,
      enableDASH: false,
      enableTSStats: false,
      enableVideoPreview: false,
      enableQam: false,
      appVersion: ""
    },
    enableSSH: false,
    showAuthModal: false,
    showUpdateModal: false
  },
  notification: {
    message: "",
    level: ""
  },
  error: {
    message: "",
    key: ""
  }
}
